import Model from "../Model";

class DivisionZone extends Model{

    buildUrl ({ param }) {
        return ['allzonebydivisionview/getallzonedata', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new DivisionZone;